export const citiesConstants = {
  FETCH_ALL_CITIES_BEGIN: 'FETCH_ALL_CITIES_BEGIN',
  FETCH_ALL_CITIES_SUCCESS: 'FETCH_ALL_CITIES_SUCCESS',
  FETCH_ALL_CITIES_ERROR: 'FETCH_ALL_CITIES_ERROR',
  FILTER_DISTRICTS:'FILTER_DISTRICTS',
};
